import { render, staticRenderFns } from "./attachmentsTable.vue?vue&type=template&id=f90f3a5c"
import script from "./attachmentsTable.vue?vue&type=script&lang=js"
export * from "./attachmentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports